<template>
    <vue-notifications :duration="6000">
        <template #body="{ item: { type, title, text, data }, close }">
            <div class="px-4 py-6 pointer-events-none sm:p-6">
                <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0" v-if="data.icon">
                                    <span class="p-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="iconClass(type)">
                                        <!-- icon -->
                                    </span>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm leading-5 font-medium text-gray-900" v-if="title">
                                        {{ title }}
                                    </p>
                                    <p class="text-sm leading-5 text-gray-500" :class="{'mt-1': title}">
                                        {{ text }}
                                    </p>
                                </div>
                                <div class="ml-4 flex-shrink-0 flex">
                                    <button class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" @click="close">
                                        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" fill-rule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </vue-notifications>
</template>

<script>
    export default {
        methods: {
            iconClass(type) {
                switch (type) {
                    case 'success':
                        return 'bg-green-100 text-green-800';
                    case 'warning':
                        return 'bg-yellow-100 text-yellow-800';
                    case 'error':
                        return 'bg-red-100 text-red-800';
                    default:
                        return 'bg-indigo-100 text-indigo-800';
                }
            },
        },
    };
</script>
